module.exports = __webpack_public_path__ + "static/hero-img-mobile@3x-dc05452a424a1f80f5c3a29bc84f31d8.png";